<template>
    <div class="mt-5">
        <!-- <h1>activacion {{ $route.params }}</h1> -->
        <h5 class="text-center">Activación de cuenta</h5>
        <small class="d-block text-center" v-if="error">{{ error }}</small>
        <kurama-loader v-if="load" :msj="loadMsj" />
    </div>
</template>
<script lang="ts">
import NotificationMixin  from '@/mixins/ResourceNotificationMixin';
import mapHelper from '@/store/modules/common/map-helper';
export default({
    mixins: [NotificationMixin ],
    data() {
        return {
            load: false,
            loadMsj: '',
           datos: {
                guid: this.$route.params.guid,
                code: this.$route.params.codigo
            },
            /*datos: {
                guid: "0114475E-9E38-4FBD-BC8A-EE074691A4B3",
                code: "664344"
            },*/
            error: null
        }
    },
    methods:{
        async client_credentials(){
            try {
                this.loadMsj = 'Procesando activación...';
                this.load = true;
                let response = (await this.$store.dispatch(mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.client_credentials));
                // console.log('client_credentials()', response);
                if(response.status == 200) this.putVerificar();
                else this.handleCerrarSesion();
            } catch (error) {
                console.log('error:::', error);
            }finally{
                this.load = false;
                this.loadMsj = '';
            }
        },
         async putVerificar(){
            try {
                this.loadMsj = 'Verificando...';
                this.load = true;
                let response = (await this.$store.dispatch(mapHelper.mapmod.SIAHE_ACTIVACION+mapHelper.mapfn.putVerificar, this.datos));
                /*console.log('putVerificar()', response);
                console.log('response.status == 200', response.status);*/
                
                if(response.status == 200){
                    this.openNotification(null,'success-sh', null,'Cuenta activada', response.message, '8000'); 
                }
            } catch (error) {
                // console.log('error:::', error);
                this.error = error;
                this.openNotification(null,'danger-sh', null,'Cuenta no activada', error, '10000'); 
            }finally{
                this.load = false;
                this.loadMsj = '';
                this.handleCerrarSesion();
            }
        },
        async handleCerrarSesion() {
            await this.$store.dispatch(
                mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.logOut
            );
            this.$router.push({ name: "Login" });
        },
        
    },
    created(){
        this.client_credentials();
       
    }
})
</script>
